export const AppConfig = {
  baseUrl: process.env.REACT_APP_BASE_API_URL,
  timeOut: process.env.REACT_APP_TIME_OUT
    ? parseInt(process.env.REACT_APP_TIME_OUT)
    : 20000,
  production: process.env.REACT_APP_PRODUCTION
};
